import { useRef, useEffect } from "react";

export const usePrevious = <T extends {}>(value: T) => {
    const ref = useRef<T>(null);
    useEffect(() => {
      ref.current = value;
    });
    return ref.current;
}